import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import Alert from "components/common/Alert";

import { AlertContext } from "context/AlertContext";
import { useState } from "react";
import { LoaderProvider } from "components/LoaderContext";
const App = () => {
  const [alert, setAlert] = useState("");
  return (
    <AlertContext.Provider value={{ alert, setAlert }}>
      <LoaderProvider>
        <Routes>
          <Route path="auth/*" element={<AuthLayout />} />
          <Route path="admin/*" element={<AdminLayout />} />
          <Route path="rtl/*" element={<RtlLayout />} />
          <Route path="/" element={<Navigate to="/admin" replace />} />
        </Routes>
      </LoaderProvider>
    </AlertContext.Provider>
  );
};

export default App;
